import { Injectable, EventEmitter } from '@angular/core';

import { Alert } from 'src/app/shared/interfaces/alert.model';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  public alertEvent: EventEmitter<Alert>;

  constructor() {
    this.alertEvent = new EventEmitter();
  }

  alert(alertData: { type: string, message: string }) {
    const alertEvent: Alert = { type: alertData.type, message: alertData.message };
    this.alertEvent.emit(alertEvent);
  }
}
